import { render, staticRenderFns } from "./RoundButtonMenu.vue?vue&type=template&id=64fe0888&"
import script from "./RoundButtonMenu.vue?vue&type=script&lang=ts&"
export * from "./RoundButtonMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports